import { Activity } from "lucide-react";
import PageHeader from "@/layout/PageHeader";

export default function MonthlyPulse() {
  return (
    <div data-testid="monthly-pulse-page">
      <PageHeader title="Monthly The Pulse" subtitle="Coming soon." />
      <div className="hm-surface p-12 text-center" data-testid="monthly-pulse-empty">
        <Activity className="h-6 w-6 text-hm-fg-subtle mx-auto mb-3" />
        <div className="text-sm text-hm-fg-muted">
          Beyond Activ's signature monthly heartbeat — deals, launches,
          people moves, and what to watch. Not wired yet.
        </div>
      </div>
    </div>
  );
}
